import { render, staticRenderFns } from "./AboutMain.vue?vue&type=template&id=6c05299f&scoped=true"
import script from "./AboutMain.vue?vue&type=script&lang=js"
export * from "./AboutMain.vue?vue&type=script&lang=js"
import style0 from "./AboutMain.vue?vue&type=style&index=0&id=6c05299f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c05299f",
  null
  
)

export default component.exports